import { useMemo } from 'react';

import { extractTankBits, toBinaryString } from '../TabPanelCondition.utils';

export const useGuardData = (transportConditionItem, galileoskyDevice) => {
    return useMemo(() => {
        if (!galileoskyDevice) {
            return {
                guardOutNumber: 0,
                guardStatusNumber: 0,
                guardOut: '000000000',
                guardStatus: '000000000',
                guardOutTank: '000000',
                guardStatusTank: '000000',
            };
        }

        const guardOutNumber = transportConditionItem.data.guard_out;
        const guardStatusNumber = transportConditionItem.data.guard_status;

        return {
            guardOutNumber,
            guardStatusNumber,
            guardOut: toBinaryString(guardOutNumber),
            guardStatus: toBinaryString(guardStatusNumber),
            guardOutTank: extractTankBits(guardOutNumber),
            guardStatusTank: extractTankBits(guardStatusNumber),
        };
    }, [transportConditionItem, galileoskyDevice]);
};
